import withInputErrorMessage from '../withInputErrorMessage';
import withMultiSelectAutosuggest from './withMultiSelectAutosuggest';
import autosuggestFactory from './autosuggestFactory';
import { getStateSuggestions } from '../../../app/services/geoDataService';
import withAutosuggestWrapper from './withAutosuggestWrapper';
import apiDataResponseHandler from "../../../util/promiseFactory/apiDataResponseHandler";

const stateAutoSuggest = autosuggestFactory({
   apiPromise: getStateSuggestions,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionFromDataPropAndLabelAsName,
   defaultPlaceholder: 'Search State...',
});

export default withAutosuggestWrapper(withInputErrorMessage(stateAutoSuggest));
export const StateMultiSelect = withMultiSelectAutosuggest(stateAutoSuggest);
